import Api from "../endpoint";

export const DashboardServices = {
  getOsDataToDashboard: data => Api.post("/dashboard", data),
}
